import * as React from "react";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import { useState, useEffect } from "react";
import { ChartHeader } from "components/Dashboard";
import debtorsIcon from "../../assets/DashboardIcons/Debtor.svg";
import { useDashboardData } from "services/dashboardService";

export const DebtorsChart = (props) => {
  const [type, setType] = useState("Month");
  const [filters, setFilters] = useState({});
  const [series, setSeries] = useState([]);

  const { data: dashboardData, loading } = useDashboardData();
  const debtorsData = dashboardData?.debtors;

  const [typesData, setTypesData] = useState([]);

  useEffect(() => {
    setFilters(props.filters);
  }, [props.filters]);

  useEffect(() => {
    if (debtorsData?.data) {
      const pieChartData = debtorsData.data.map((item) => ({
        key: item.key,
        amount: item.amount,
      }));
      setSeries(pieChartData);
    } else {
      setSeries([]);
    }
  }, [debtorsData?.data]);

  useEffect(() => {
    typesUpdater();
  }, [filters, type]);

  const typesUpdater = () => {
    let types = [];
    if (filters?.feeEarnerRef === null) {
      types.push({
        label: "By Fee Earner",
        value: "FeeEarner",
      });
    }
    if (filters?.appCode === null) {
      types.push({
        label: "By App",
        value: "Application",
      });
    }
    if (filters?.branch === null) {
      types.push({
        label: "By Branch",
        value: "Branch",
      });
    }
    if (filters?.month === null) {
      types.push({
        label: "By Month",
        value: "Month",
      });
    }
    setTypesData(types);

    let check = false;
    types.forEach((item) => {
      if (item.value === type) {
        check = true;
      }
    });
    if (!check) {
      setType("Month");
    }
  };

  const chartDefaultV4Colors = [
    "#241CCA",
    "#FF9E16",
    "#F1F0FF",
    "#96A0FF",
    "#00A8E1",
    "#0055B8",
  ];

  return (
    <div className="h-100 p-2">
      <ChartHeader
        name={"Debtors"}
        type={"(Age Debtors vs Age Creditors)"}
        icon={debtorsIcon}
        color={"#F5F5F5"}
        duration={filters?.duration}
        iconWidth={26}
        iconHeight={26}
      />
      <div className="h-100 p-2">
        {loading ? (
          <div className="h-100 p-2 d-flex align-items-center justify-content-center">
            <div className="text-muted">Loading debtors data...</div>
          </div>
        ) : (
          <Chart
            style={{
              height: 225,
            }}
            seriesColors={chartDefaultV4Colors}
          >
            <ChartSeries>
              <ChartSeriesItem
                type="pie"
                overlay={{
                  gradient: "sharpBevel",
                }}
                tooltip={{
                  visible: true,
                }}
                data={series}
                categoryField="key"
                field="amount"
              />
            </ChartSeries>
          </Chart>
        )}
      </div>
    </div>
  );
};
